'use client';

import React__default, { useRef, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Tooltip from '../Tooltip/index.js';
import { ELanguage } from '../Utils/constants.js';
import facebookColorIcon from './images/facebook-color.svg.js';
import facebookIcon from './images/facebookIcon.svg.js';
import linkedInIcon from './images/inIcon.svg.js';
import linkColorIcon from './images/link-color.svg.js';
import linkedInColorIcon from './images/linkedin-color.svg.js';
import linkIcon from './images/linkIcon.svg.js';
import twitterColorIcon from './images/twitterColor.svg.js';
import twitterIcon from './images/twitterIcon.svg.js';
import zaloColorIcon from './images/zalo-color.svg.js';
import zaloIcon from './images/zaloIcon.svg.js';
import { DivShare, IconsContainer, IconWrap } from './SocialShare.css.js';
import ShareIcon from '../Images/ShareIcon/index.js';
import Typography from '../Typography/index.js';
import { colors } from '../Colors/index.js';
import SocialMedia from '../icons/SocialMediaGroupIcons/index.js';
import Misc from '../icons/MiscGroupIcons/index.js';

/* eslint-disable no-unused-vars */
function SocialShare(props) {
    var _a;
    var lang = props.lang, isNewShareSocial = props.isNewShareSocial;
    var btnRefList = useRef([]);
    var _b = useState(false), showCopyLinkTooltip = _b[0], setShowCopyLinkTooltip = _b[1];
    // Copy the current address bar link
    var copyAddressBarLink = function () {
        // Create a temporary textarea element
        var textArea = document.createElement('textarea');
        textArea.id = 'copyTextArea';
        textArea.style.position = 'absolute';
        textArea.style.opacity = '0';
        document.body.append(textArea);
        // Set the content of the area with the current HREF
        textArea.innerHTML = window.location.href;
        // Copy the value of the textarea
        textArea.select();
        document.execCommand('copy');
        textArea.remove();
        setShowCopyLinkTooltip(true);
        setTimeout(function () {
            setShowCopyLinkTooltip(false);
        }, 2000);
    };
    // Add scripts on load
    useEffect(function () {
        // Zalo Script
        var zaloShareElement = document.querySelector('#share-zalo-script');
        if (!zaloShareElement) {
            // Add - readd zalo script
            var zaloScriptTag = document.createElement('script');
            zaloScriptTag.type = 'text/javascript';
            zaloScriptTag.id = 'share-zalo-script';
            zaloScriptTag.src = 'https://sp.zalo.me/plugins/sdk.js';
            document.body.append(zaloScriptTag);
        }
        // Rebinding click events from ZaloSDK
        if (btnRefList.current.length > 0) {
            btnRefList.current.forEach(function (btn) {
                var domEl = ReactDOM.findDOMNode(btn);
                if (domEl) {
                    var innerHTML = domEl.innerHTML;
                    domEl.innerHTML = '';
                    domEl.innerHTML = innerHTML;
                }
            });
            if (zaloShareElement) {
                typeof ZaloSocialSDK !== 'undefined' && ZaloSocialSDK.reload();
            }
        }
    }, []);
    // Get page title and page URL
    var currentHref = '';
    var pageTitle = '';
    if (typeof window !== 'undefined') {
        pageTitle = encodeURIComponent(((_a = document.querySelector('meta[property="og:title"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) || '');
        currentHref = encodeURIComponent(window.location.href);
    }
    // Get share links
    var facebookShareLink = "https://www.facebook.com/sharer.php?t=".concat(pageTitle, "&u=").concat(currentHref);
    var twitterShareLink = "https://twitter.com/intent/tweet?text=".concat(pageTitle, "&url=").concat(currentHref);
    var linkedinShareLink = "https://www.linkedin.com/shareArticle?title=".concat(pageTitle, "&url=").concat(currentHref);
    // Open new window with size method
    var openInNewWindow = function (link) {
        var left = window.innerWidth / 2 - 720 / 2;
        var top = window.innerHeight / 2 - 480 / 2;
        window.open(link, '_blank', "toolbar=no,\n                    location=no,\n                    status=no,\n                    menubar=no,\n                    scrollbars=yes,\n                    resizable=yes,\n                    width=720,\n                    height=480\n                    top=".concat(top, ",\n                    left=").concat(left, "\n                    "));
    };
    return (React__default.createElement(DivShare, { className: 'share-button-group', isNewShareSocial: isNewShareSocial },
        React__default.createElement("div", { className: 'share-text' },
            isNewShareSocial && React__default.createElement(ShareIcon, null),
            React__default.createElement(Typography, { variant: 'span', color: colors.grey[50], name: 'paragraph', size: 'medium' },
                lang === ELanguage.EN ? 'Share' : 'Chia sẻ',
                ":")),
        React__default.createElement(IconsContainer, { isNewShareSocial: isNewShareSocial },
            isNewShareSocial ? (React__default.createElement(IconWrap, { onClick: function () { return openInNewWindow(facebookShareLink); } },
                React__default.createElement(SocialMedia.FacebookIconColorFull, { width: 24, height: 24 }))) : (React__default.createElement("span", { onClick: function () { return openInNewWindow(facebookShareLink); }, className: 'btn-share btn-share-facebook' },
                React__default.createElement("img", { src: facebookIcon, alt: 'Share on Facebook' }),
                React__default.createElement("img", { src: facebookColorIcon, alt: 'Share on Facebook' }))),
            isNewShareSocial ? (React__default.createElement(IconWrap, { ref: function (el) { return el && btnRefList.current.push(el); } },
                React__default.createElement(SocialMedia.ZaloIconColorFull, { width: 24, height: 24 }),
                React__default.createElement("div", { className: 'zalo-share-button', "data-href": '', "data-oaid": '935978607505933955', "data-layout": '2', "data-color": 'blue', "data-customize": true }))) : (React__default.createElement("span", { className: 'btn-share', ref: function (el) { return el && btnRefList.current.push(el); } },
                React__default.createElement("img", { src: zaloIcon, alt: 'Share on Zalo' }),
                React__default.createElement("img", { src: zaloColorIcon, alt: 'Share on Zalo' }),
                React__default.createElement("div", { className: 'zalo-share-button', "data-href": '', "data-oaid": '935978607505933955', "data-layout": '2', "data-color": 'blue', "data-customize": true }))),
            isNewShareSocial ? (React__default.createElement(IconWrap, { onClick: function () { return openInNewWindow(twitterShareLink); } },
                React__default.createElement(SocialMedia.TwitterIconColorFull, { width: 24, height: 24 }))) : (React__default.createElement("span", { onClick: function () { return openInNewWindow(twitterShareLink); }, className: 'btn-share btn-share-twitter' },
                React__default.createElement("img", { src: twitterIcon, alt: 'Share on Twitter' }),
                React__default.createElement("img", { src: twitterColorIcon, alt: 'Share on Twitter' }))),
            isNewShareSocial ? (React__default.createElement(IconWrap, { onClick: function () { return openInNewWindow(linkedinShareLink); } },
                React__default.createElement(SocialMedia.LinkedinIconColorFull, { width: 24, height: 24 }))) : (React__default.createElement("span", { onClick: function () { return openInNewWindow(linkedinShareLink); }, className: 'btn-share btn-share-linkedin' },
                React__default.createElement("img", { src: linkedInIcon, alt: 'Share on LinkedIn' }),
                React__default.createElement("img", { src: linkedInColorIcon, alt: 'Share on LinkedIn' }))),
            isNewShareSocial ? (React__default.createElement(IconWrap, { isBorder: true, onClick: copyAddressBarLink },
                React__default.createElement(Misc.LinkIcon, { width: 20, height: 20 }),
                React__default.createElement(Tooltip, { isShow: showCopyLinkTooltip, placement: 'left', customStyle: { width: '200px' }, description: lang === ELanguage.EN ? "\u2713 Page Link Was Copied!" : "\u2713 Li\u00EAn k\u1EBFt trang \u0111\u00E3 \u0111\u01B0\u1EE3c sao ch\u00E9p!" }))) : (React__default.createElement("span", { onClick: copyAddressBarLink, className: 'btn-share copy-link', style: { position: 'relative' } },
                React__default.createElement("img", { src: linkIcon, alt: 'Copy the current link' }),
                React__default.createElement("img", { src: linkColorIcon, alt: 'Copy the current link' }),
                React__default.createElement(Tooltip, { isShow: showCopyLinkTooltip, placement: 'left', customStyle: { width: '200px' }, description: lang === ELanguage.EN ? "\u2713 Page Link Was Copied!" : "\u2713 Li\u00EAn k\u1EBFt trang \u0111\u00E3 \u0111\u01B0\u1EE3c sao ch\u00E9p!" }))))));
}

export { SocialShare as default };
//# sourceMappingURL=index.js.map
